import React, { useEffect, useState, } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Modal from 'react-bootstrap/Modal'
import VideoModal from './videoModal/VideoModal';
import { ReactSession } from 'react-client-session';
import { useNavigate, useLocation as useReactLocation } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

const navigationItems = [
    { key: 'overview', label: 'Overview', imageInactive: '/assets/images/newui/overview.svg', imageActive: '/assets/images/newui/overview1.svg' },
    { key: 'navigator', label: 'Navigator', imageInactive: '/assets/images/newui/navigator.svg', imageActive: '/assets/images/newui/navigator1.svg' },
    { key: 'location', label: 'Location', imageInactive: '/assets/images/newui/location.svg', imageActive: '/assets/images/newui/location1.svg' },
    { key: 'VirtualTour', label: 'Virtual Tour', imageInactive: '/assets/images/newui/amenities.svg', imageActive: '/assets/images/newui/amenities1.svg' },
    { key: 'gallery', label: 'Gallery', imageInactive: '/assets/images/newui/gallery.svg', imageActive: '/assets/images/newui/gallery1.svg' },
];

const Navbar = (props) => {

    const [videosModalShow, setVideosModalShow] = useState(false);
    const [hideLogo, setHideLogo] = useState(false);
    const handleVideosModalClose = () => setVideosModalShow(false);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [loactionName, setLocationName] = useState('Overview');
    const [isFullscreen, setIsFullscreen] = useState(false);
    const navigate = useNavigate();
    const location = useReactLocation();
    const [activeNavItem, setActiveNavItem] = useState(localStorage.getItem('activeNavItem') || 'overview'); // Set 'overview' as the default activeNavItem

    const handleClick = (itemKey) => {
        setActiveNavItem(itemKey);
        localStorage.setItem('activeNavItem', itemKey);
        navigate(`/${itemKey}`);
    };

    useEffect(() => {
        if (ReactSession.get("nav-logo") === undefined) {
            ReactSession.setStoreType("localStorage");
            ReactSession.set("nav-logo", true)
            setHideLogo(true)
        } else {
            setHideLogo(ReactSession.get("nav-logo"))
        }
    }, []);
    useEffect(() => {
        // Update activeNavItem based on the current route
        const currentRoute = location.pathname.slice(1); // Remove the leading "/"
        if (currentRoute !== "blockSelction") {
            setActiveNavItem(currentRoute || "overview");
        }
    }, [location.pathname]);

    const toggleFullscreen = () => {
        const isIpadChrome = /CriOS/.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.platform);

        if (isIpadChrome) {
            // Disable full-screen on iPad and iPhone using Chrome
            alert("Chrome on iPad and iPhone does not support full-screen mode.");
            return;
        }
        if (!isFullscreen) {
            // Enter fullscreen mode
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) { // Firefox
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
                document.documentElement.msRequestFullscreen();
            }
        } else {
            // Exit fullscreen mode
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        }
    };
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);
    async function signOut() {
        try {
            await Auth.signOut();
            navigate("/");
            return window.location.reload();
        } catch (error) {
            // console.log("error signing out: ", error);
        }
    }
    return (
        <>
            <div className='new_Navbar'>
                <ul className="navbar-nav mb-0 projectDetailSectionTabs">
                    {navigationItems.map((item) => (
                        <li key={item.key} className="nav-item">
                            <NavLink
                                onClick={() => handleClick(item.key)}
                                className={`nav-link navbarMenu`}
                                to={`/${item.key}`}
                            >
                                <ReactTooltip
                                    id={item.label}
                                    place="right"
                                    content={item.label}
                                />
                                <img
                                    data-tooltip-id={item.label}
                                    src={activeNavItem === item.key ? item.imageActive : item.imageInactive}
                                    alt={item.label}
                                />
                            </NavLink>
                        </li>
                    ))}
                </ul>
                <div className='navigator_box'>
                    <h3>{activeNavItem}</h3>
                    <div data-tooltip-id="my-tooltip-1" className='fullScreenBox' onClick={toggleFullscreen} style={{ cursor: "pointer", marginBottom: "10px" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#eb5f1f" className="bi bi-fullscreen" viewBox="0 0 16 16">
                            <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z" />
                        </svg>
                    </div>
                    {/* <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#eb5f1f" className="bi bi-arrow-left" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                        </svg>
                    </div> */}
                    <button data-tooltip-id="my-tooltip-2" className="sign-out" onClick={() => { signOut() }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path id="logout_icon" data-name="logout icon" d="M20,7.8,18.308,9.492,21.4,12.6H9.2V15H21.4l-3.1,3.1L20,19.8l6-6ZM4.4,5.4H14V3H4.4A2.407,2.407,0,0,0,2,5.4V22.2a2.407,2.407,0,0,0,2.4,2.4H14V22.2H4.4Z" transform="translate(-1.75 -2.75)" fill="#fff" stroke="#fff" strokeWidth="0.5" />
                        </svg>
                        <span className="logout"></span>
                    </button>
                    <ReactTooltip
                        id="my-tooltip-1"
                        place="right"
                        content="FullScreen"
                    />
                    <ReactTooltip
                        id="my-tooltip-2"
                        place="right"
                        variant="info"
                        content="Logout"
                    />
                </div>
            </div>
        </>
    )
}
export default Navbar;